import api from '@/api'
import contacts from '@/api/apiSferest/services/contacts'

const mapContactData = ({ id, type, source, name, tradeName, lastName, document, contactMedium, managerBody, receiverCode }) => {
  let managerbodyCode = managerBody ? managerBody.code : null
  let department = contactMedium ? contactMedium.departmentCode : null
  tradeName = source === 'promoter' && !!department
                ? department
                : type === 'NP' && !!lastName
                  ? `${tradeName} ${lastName}`
                  : tradeName
  return {
    id,
    source,
    document,
    name,
    tradeName,
    managerbodyCode,
    department,
    receiverCode
  }
}

export const getList = ({ commit, state, getters, dispatch }) => {
  dispatch('loading')
  return new Promise((resolve, reject) => {
    let params = {
      ...getters['query'],
      sort: state.search.sort || 'name',
      limit: state.search.limit
    }
    contacts.list(params)
    .then((res) => {
      commit('list/SET_LIST', res.data.map(contact => mapContactData(contact)))
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
      dispatch('loaded')
    })
  })
}

export const getMore = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.apiSferest.get(state.search.more, { data: {} })
    .then((res) => {
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        reject(new Error('Error de conexión'))
        return
      }
      commit('list/ADD_TO_LIST', res.data.map(contact => mapContactData(contact)))
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_TRADENAME', '')
    commit('SET_NAME', '')
    commit('SET_DOCUMENT', '')
    commit('SET_DEPARTMENT', '')
    commit('SET_MANAGERBODYCODE', '')
    commit('SET_RECEIVERCODE', '')
    commit('search/SET_MORE', undefined)
    commit('search/SET_LIMIT', 10)
    commit('search/SET_SORT', undefined)
    resolve()
  })
}

export const remove = ({ commit, dispatch }, selected) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      contacts.remove('personal',
        selected.filter(x => x.source !== 'promoter').map(x => x.id)
      ).then((res) => {
        resolve(res)
      })
    })
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
